import { BRAND } from "@/lib/brand";
import { useCompany } from "@/context/CompanyContext";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Cross Jobs product mark: shield + wordmark.
export const BrandMark = ({ size = "md", tone = "dark", className = "" }) => {
  const img = { sm: "h-8", md: "h-9", lg: "h-12" }[size];
  const text = size === "lg" ? "text-2xl" : "text-lg";
  const color = tone === "light" ? "text-white" : "text-[#1E3A5F] dark:text-white";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
      <img src={BRAND.mark} alt="" className={`${img} w-auto`} />
      <span className={`font-display font-black uppercase tracking-tight leading-none ${text} ${color}`}>
        Cross Jobs
      </span>
    </span>
  );
};

// Header logo: the company's own logo, else the shield + company name, else Cross Jobs.
export const CompanyLogo = ({ compact = false }) => {
  const { company } = useCompany();
  if (company?.logo_url) {
    return (
      <img src={`${BACKEND}${company.logo_url}`} alt={company.name} data-testid="company-logo"
        className="h-9 w-auto max-w-[170px] object-contain rounded-md" />
    );
  }
  if (company?.name && company.name !== BRAND.name) {
    return (
      <span className="inline-flex items-center gap-2.5 min-w-0" data-testid="company-logo">
        <img src={BRAND.mark} alt="" className="h-9 w-auto shrink-0" />
        <span className={`font-display font-bold text-lg truncate max-w-[180px] ${compact ? "hidden sm:inline" : ""}`} data-testid="company-name">{company.name}</span>
      </span>
    );
  }
  return <BrandMark />;
};
